


































import { defineComponent } from '@nuxtjs/composition-api';
import useCartCookie from '@shared/composables/useCartCookie';
import useShopifyDiscounts from '@shared/composables/useShopifyDiscounts';
import useUiState from '@shared/composables/useUiState';
import { UCIcon } from '@shared/ui';
import { cartGetters } from '@unified-commerce/gpc-vue-storefront-shopify';
export default defineComponent({
  name: 'RecentlyAddedSidebarActions',
  components: {
    UCIcon,
  },
  setup(_, { emit }) {
    const { hasUnclaimedGifts } = useShopifyDiscounts();
    const { toggleCartSidebar } = useUiState();
    const { cart } = useCartCookie();

    const onClose = () => emit('on-close');

    const handleCheckout = () => {
      window.location.href = cartGetters.getcheckoutURL(cart.value);
    };

    return {
      handleCheckout,
      onClose,
      hasUnclaimedGifts,
      toggleCartSidebar,
    };
  },
});
